import { toArray as g, unrefElement as A, tryOnScopeDispose as D } from "@vueuse/core";
import { notNullish as y } from "../../../../@vueuse_shared@13.1.0_vue@3.5.13_typescript@5.8.3_/node_modules/@vueuse/shared/index.js";
import { createFocusTrap as F } from "focus-trap";
import { shallowRef as n, computed as T, toValue as i, watch as w } from "vue";
function N(f, a = {}) {
  let t;
  const { immediate: l, ...p } = a, o = n(!1), r = n(!1), c = (e) => t && t.activate(e), u = (e) => t && t.deactivate(e), v = () => {
    t && (t.pause(), r.value = !0);
  }, m = () => {
    t && (t.unpause(), r.value = !1);
  }, h = T(() => {
    const e = i(f);
    return g(e).map((d) => {
      const s = i(d);
      return typeof s == "string" ? s : A(s);
    }).filter(y);
  });
  return w(
    h,
    (e) => {
      e.length && (t = F(e, {
        ...p,
        onActivate() {
          o.value = !0, a.onActivate && a.onActivate();
        },
        onDeactivate() {
          o.value = !1, a.onDeactivate && a.onDeactivate();
        }
      }), l && c());
    },
    { flush: "post" }
  ), D(() => u()), {
    hasFocus: o,
    isPaused: r,
    activate: c,
    deactivate: u,
    pause: v,
    unpause: m
  };
}
export {
  N as useFocusTrap
};
